import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import Spinner from './ui/Spinner';
import PageHeader from './ui/PageHeader';
import Alert from './ui/Alert';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'http://localhost:8000';

const McpReference = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSkill = async () => {
      try {
        const response = await fetch(`${API_BASE}/mcp`);
        if (!response.ok) throw new Error('Failed to load reference');
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchSkill();
  }, []);

  return (
    <div className="page page-narrow">
      <PageHeader title="MCP reference" subtitle="How agents and CLI tools talk to the console API" />
      {loading ? (
        <Spinner label="Loading API reference…" />
      ) : error ? (
        <Alert type="error">{error}</Alert>
      ) : (
        <div className="card" style={{ padding: '24px', lineHeight: 1.7 }}>
          <style>{`
            .mcp-ref > :first-child { margin-top: 0; }
            .mcp-ref h1 { font-size: 24px; border-bottom: 1px solid var(--color-border); padding-bottom: 10px; margin-top: 30px; }
            .mcp-ref h2 { font-size: 20px; border-bottom: 1px solid var(--color-border); padding-bottom: 8px; margin-top: 28px; }
            .mcp-ref h3 { font-size: 16px; margin-top: 24px; }
            .mcp-ref pre { background: var(--color-bg); border: 1px solid var(--color-border); border-radius: var(--radius); padding: 16px; overflow-x: auto; font-size: 13px; line-height: 1.5; }
            .mcp-ref code { font-family: var(--font-mono); background: var(--color-bg); padding: 2px 6px; border-radius: 3px; font-size: 13px; }
            .mcp-ref pre code { background: none; padding: 0; }
            .mcp-ref table { border-collapse: collapse; width: 100%; margin: 16px 0; font-size: 14px; }
            .mcp-ref th { background: var(--color-bg); border: 1px solid var(--color-border); padding: 8px 12px; text-align: left; font-weight: 600; }
            .mcp-ref td { border: 1px solid var(--color-border); padding: 8px 12px; }
            .mcp-ref ul, .mcp-ref ol { padding-left: 24px; }
            .mcp-ref li { margin-bottom: 4px; }
            .mcp-ref hr { border: none; border-top: 1px solid var(--color-border); margin: 24px 0; }
            .mcp-ref a { color: var(--color-primary); text-decoration: none; }
            .mcp-ref a:hover { text-decoration: underline; }
            .mcp-ref blockquote { border-left: 4px solid var(--color-border); padding: 8px 16px; margin: 16px 0; color: var(--color-muted); background: var(--color-bg); }
          `}</style>
          <div className="mcp-ref">
            <ReactMarkdown>{content}</ReactMarkdown>
          </div>
        </div>
      )}
    </div>
  );
};

export default McpReference;
